import React from 'react'
import Helmet from 'react-helmet'
import { useIsTenant } from '../../contexts/TenantContext'
import constants from '../../common/constants'

const Head = ({ info }) => {
  const isSod = useIsTenant(constants.tenant.SOD)
  const defaultTitle = isSod ? 'Supermercado Online' : 'Mundo Lider'
  const title = info ? info.title : defaultTitle
  return (
    <Helmet>
      <title>{`${title} | Lider.cl`}</title>
      <meta name="title" content={`${title} | Lider.cl`} />
      <meta
        name="keywords"
        content="Lider, Lider.cl, LCD, juguetes, computadoras, notebook, cámaras, cámaras digitales, videojuegos, celulares, electro domésticos, línea blanca, mp3, reproductores de mp3, televisores, pantallas, supermercado online, supermercado, precios bajos"
      />
      <meta
        name="description"
        content="Compra online en simples pasos y con despacho a domicilio en Lider.cl. Descubre nuestros precios increíbles."
      />
      <meta property="og:title" content={`${title} | Lider.cl`} />
      <meta
        property="og:description"
        content="Compra online en simples pasos y con despacho a domicilio en Lider.cl. Descubre nuestros precios increíbles."
      />
      <meta property="og:type" content="product.group" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={`${title} | Lider.cl`} />
      <meta
        property="twitter:description"
        content="Compra online en simples pasos y con despacho a domicilio en Lider.cl. Descubre nuestros precios increíbles."
      />
    </Helmet>
  )
}

export default Head
